import React from 'react';
import styles from './ActorCard.module.css';
import ActorCardImage from './ActorCardImage';
import ActorCardInfo from './ActorCardInfo';

/**
 * @component ActorCard
 * @description 배우 프로필 카드 (공통 컴포넌트)
 *
 * 이미지 영역(ActorCardImage)이 독립 컴포넌트로 분리되어 있어
 * src props 값만 교체하면 실제 이미지로 전환된다.
 *
 * @param {string|null} props.image    - 이미지 경로 (null이면 플레이스홀더)
 * @param {string}      props.name     - 배우 이름
 * @param {string}      props.gender   - 성별
 * @param {number}      props.age      - 나이
 * @param {number}      props.height   - 키 (cm)
 * @param {string[]}    props.skills   - 보유 기술 배열
 * @param {Function}    props.onClick  - 카드 클릭 핸들러
 * @param {string}      props.className
 */
function ActorCard({
  image,
  name,
  gender,
  age,
  height,
  skills,
  onClick,
  className = '',
}) {
  const cardClasses = [styles.actorCard, className].filter(Boolean).join(' ');

  return (
    <article className={cardClasses} onClick={onClick}>
      <ActorCardImage src={image} alt={name} name={name} />
      <ActorCardInfo
        name={name}
        gender={gender}
        age={age}
        height={height}
        skills={skills}
      />
    </article>
  );
}

export default ActorCard;
